import React from 'react';
import { useStore } from 'react-context-hook';
import { FaChevronRight } from 'react-icons/fa';
import { VideoPlayer } from '@app/components/atm.video-player';
import { Modal } from '@atomic/obj.modal';
import { CircledLabel, ListCard, PillBadge } from '@atomic/v3';
import { montarAcoesMateriais } from './challenges-v3.actions';
// Mesmo comportamento do CourseLibraryItem: abre as fases, o PDF (link) e o vídeo.
export var ChallengeItemV3 = function (_a) {
    var _b, _c, _d;
    var course = _a.course, courseIndex = _a.courseIndex;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _e = useStore('currentLibraryCourse'), _ = _e[0], setCurrentLibraryCourse = _e[1];
    var _f = React.useState(false), isVideoPlayerModalOpen = _f[0], setIsVideoPlayerModalOpen = _f[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(ListCard, { leading: React.createElement(CircledLabel, { label: "D." + (courseIndex + 1) }), title: course === null || course === void 0 ? void 0 : course.nome, trailing: React.createElement(PillBadge, null,
                "Ver fases ",
                React.createElement(FaChevronRight, { size: 10 })), onClick: function () { return setCurrentLibraryCourse(course); }, actions: montarAcoesMateriais({
                pdfUrl: (_b = course === null || course === void 0 ? void 0 : course.arquivo) === null || _b === void 0 ? void 0 : _b.url,
                onAssistirVideo: ((_c = course === null || course === void 0 ? void 0 : course.video) === null || _c === void 0 ? void 0 : _c.url) ? function () { return setIsVideoPlayerModalOpen(true); } : undefined,
            }) }),
        React.createElement(Modal, { opened: isVideoPlayerModalOpen, onClose: function () { return setIsVideoPlayerModalOpen(false); } },
            React.createElement(VideoPlayer, { videoUrl: (_d = course === null || course === void 0 ? void 0 : course.video) === null || _d === void 0 ? void 0 : _d.url }))));
};
